/**
 * In application/x-www-form-urlencoded (query params), + is decoded as space,
 * so e.g. jaynam+tag@paysense.in becomes "jaynam tag@paysense.in".
 * Restore all plus signs by replacing spaces with +.
 * (Other chars: %XX is decoded by the parser, e.g. %40→@, %2B→+; no extra handling needed.)
 */
export const decodeEmailFromQuery = value => {
  const trimmed = value?.trim() || ''
  return trimmed ? trimmed.replace(/ /g, '+') : ''
}
